var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cmp-cart-item-row cy--cart-items--item-row",class:{
    bordered: _vm.bordered,
    'item-disabled': _vm.isDisabled,
    'bundle-row': _vm.isItemBundle,
  }},[_c('div',{staticClass:"root-item-wrap"},[(_vm.get(_vm.item, 'id'))?_c('cart-item',{attrs:{"item":_vm.itemExtended}}):_vm._e(),_vm._t("default"),(_vm.isItemBundle)?_c('cart-item-bundle',{attrs:{"item":_vm.item}}):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }